import React from 'react';
import Minimap from '../../FlowchartView/components/Minimap';
import FlowchartHUD from '../../FlowchartView/components/FlowchartHUD';
import FocusModeHUD from '../../FlowchartView/components/FocusModeHUD';
import FokusOverlay from '../../shared/FokusOverlay';
import { findPreferredStatus } from '../../FlowchartView/utils/statusUtils';

function BoardChrome({
  flow,
  tasks,
  statuses,
  lockStates,
  goToTask,
  graph,
  edges,
  cameraRef,
  wrapRef,
  fokus = null,
}) {
  return (
    <>
      <FlowchartHUD
        sprintName={flow.sprintName}
        sprintIcon={flow.sprintIcon}
        progress={flow.sprintProgress}
        tasks={tasks}
        statuses={statuses}
        lockStates={lockStates}
        nestedSprints={flow.nestedSprints || []}
        allSprints={flow.allSprints || []}
        isHidden={!!fokus?.active}
        onGoToTask={goToTask}
        onStartTask={(taskId) => {
          const preferred = findPreferredStatus(statuses, 'in_progress');
          flow.onStatusChange?.(taskId, preferred?.id || 'in_progress');
        }}
        onCompleteTask={(taskId) => {
          const preferred = findPreferredStatus(statuses, 'completed');
          flow.onStatusChange?.(taskId, preferred?.id || 'completed');
        }}
        breadcrumbPath={flow.breadcrumbPath || []}
        onNavigateToParent={flow.onNavigateToParent}
        onSelectSprint={flow.onSelectSprint}
        onRename={flow.onRenameSprint}
        onIconChange={flow.onSprintIconChange}
        campaignId={flow.campaignId}
        isMultiCampaignMode={!!flow.isMultiCampaignMode}
        flowViewVisibility={flow.flowViewVisibility || {}}
        onFlowViewVisibilityChange={flow.onFlowViewVisibilityChange}
        hideViewExplainerModal={flow.hideViewExplainerModal}
        onHideViewExplainerModalChange={flow.onHideViewExplainerModalChange}
      />
      {flow.flowViewVisibility?.minimap !== false && (
        <div className="board-view__navigator">
          <Minimap
            tasks={tasks}
            nodePositions={graph.nodePositions}
            nodeDimensions={graph.nodeDimensions}
            edges={edges}
            pan={cameraRef.current}
            zoom={cameraRef.current.zoom}
            containerRef={wrapRef}
            contentBounds={graph.contentBounds}
            onPanChange={(pan) => {
              cameraRef.current = { ...cameraRef.current, x: pan.x, y: pan.y };
            }}
            allCategories={flow.allCategories || []}
            allTags={flow.allTags || []}
            lockStates={lockStates}
            statuses={statuses}
            nestedSprints={flow.nestedSprints || []}
            campaignId={flow.campaignId}
          />
        </div>
      )}
      {fokus?.active && <FokusOverlay />}
      <FocusModeHUD
        campaignName={flow.sprintName}
        progress={flow.sprintProgress || 0}
        focusedCount={fokus?.focusedCount || 0}
        totalVisibleCount={fokus?.totalVisibleCount || 0}
        onExitFocus={fokus?.onExit}
        isVisible={!!fokus?.active}
      />
    </>
  );
}

export default BoardChrome;
